import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/img/logo_ambar_v1.png';
import './Menu.css';
import BotaoContato from '../BotaoContato/BotaoContato.js';

function Navbar() {

  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  return (
   <nav className="navbar navbar-expand-lg navbar-light bg-light scroll-reveal-opacity" role="navigation" aria-label="Menu principal">
  <div className="container">
    {/* Logo + slogan */}
    <Link className="navbar-brand d-flex align-items-center scroll-reveal-opacity" to="/" aria-label="Página inicial Âmbar - Engenharia e Meio Ambiente em Juiz de Fora">
      <img 
        src={logo} 
        alt="Logo Âmbar - Engenharia e Meio Ambiente em Juiz de Fora" 
        style={{ height: '50px', marginRight: '10px' }} 
      />
    </Link>

    {/* Botão hamburguer */}
    <button
      className="navbar-toggler scroll-reveal-opacity"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Abrir menu de navegação"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* Itens do menu */}
    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item scroll-reveal-opacity">
          <a className="nav-link" href="/">Home</a>
        </li>
        <li className="nav-item scroll-reveal-opacity">
          <a className="nav-link" onClick={() => goToSection("servicos")}>Serviços</a>
        </li>
        <li className="nav-item scroll-reveal-opacity">
          <a className="nav-link" onClick={() => goToSection("clientes")}>Clientes</a>
        </li>
        <li className="nav-item scroll-reveal-opacity">
          <a className="nav-link" onClick={() => goToSection("equipe")}>Equipe</a>
        </li>
        <li className="nav-item scroll-reveal-opacity">
          <a className="nav-link" onClick={() => goToSection("projetos")}>Projetos</a>
        </li>
        <li className="nav-item scroll-reveal-opacity">
          <BotaoContato texto="Contato" rota="https://wa.me/5532984053160" />
        </li>
      </ul>
    </div>
  </div>
</nav>

  );
}

export default Navbar;
